<template>
<!-- 空值显示 -->
    <div class='empty'>
        <el-empty :image-size="50">
            <p slot="description" class='empty_text'>暂无数据</p>
        </el-empty>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
.empty {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    .empty_text {
        font-size: 12px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/components/Empty.vue